import React, { useEffect, useState } from "react";
import axios from "axios";
import { IMAGE_URL, URL_API } from "../../variable";
import { css } from "@emotion/react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import moment from "moment";
import { toast } from "react-toastify";
import { Link, useHistory } from "react-router-dom";

function SliderList() {
  const loaderCss = css`
    margin: auto;
  `;

  const history = useHistory();

  const [sliders, setSliders] = useState([]);

  useEffect(() => {
    getSliders();
    const interval = setInterval(() => {
      getSliders();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const getSliders = () => {
    axios.get(URL_API + "auth/admin/sliders").then((response) => {
      if (response.data.status === 200) {
        setSliders(response.data.sliders);
      }
    });
  };

  const destroySlider = (id) => {
    axios.post(URL_API + `auth/admin/slider-destroy/${id}`).then((response) => {
      if (response.data.status === 200) {
        history.push("/admin/sliders");
        toast.success("Slider Deleted Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
        getSliders();
      }
    });
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4" style={{ fontWeight: "100" }}>
                  Barakah Hijama | <i class="fa fa-home" aria-hidden="true"></i> |
                  Sliders
                </CardTitle>
              </CardHeader>
              <div
                style={{
                  paddingLeft: "80%",
                  paddingBottom: "2%",
                  fontSize: "16px",
                }}
              >
                <Link to={`/admin/slider/create`}>
                  <strong>Add Slider + </strong>
                </Link>
              </div>
              <CardBody>
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>#</th>
                      <th>Title</th>
                      <th>Image</th>
                      <th>Created At</th>
                      <th>Action</th>
                      {/* <th className="text-right">Salary</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {
                      // loading ? (
                      //   <div>
                      //     <BeatLoader
                      //       css={loaderCss}
                      //       size="12"
                      //       color="#4cd964"

                      //       loading
                      //     />
                      //     <br />
                      //     <br />
                      //   </div>
                      // ) : (
                      sliders?.map(
                        (slider, index) => {
                          return (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{slider?.title}</td>
                              <td>
                                <img
                                  height="100px"
                                  width="200px"
                                  src={IMAGE_URL + slider?.image}
                                />
                              </td>
                              <td>
                                {moment(slider?.created_at).format(
                                  " DD MMMM,YYYY"
                                )}
                              </td>
                              <td>
                                {/* <a
                                  style={{ color: "#77ac54" }}
                                  href={`slider/detail/${slider.id}`}
                                >
                                  <i class="fas fa-eye fa-lg"></i>
                                </a>
                                &nbsp;&nbsp;&nbsp;&nbsp; */}
                                <Link to={`slider/edit/${slider.id}`}>
                                  <i class="far fa-edit fa-lg"></i>
                                </Link>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <a
                                  style={{ color: "red" }}
                                  onClick={() => destroySlider(slider.id)}
                                >
                                  <i class="fas fa-trash-alt fa-lg"></i>
                                </a>
                              </td>
                            </tr>
                          );
                        }
                        // )
                      )
                    }
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default SliderList;
